var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('breadcrumb',{attrs:{"link-list":_vm.breadcrumbList}}),_c('div',{staticClass:"ql-container ql-snow"},[_c('p',{staticClass:"agreement ql-editor",domProps:{"innerHTML":_vm._s(_vm.pageInfo)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }